<template>
  <div class="overview-map" ref="toMap" :style="style"></div>
</template>
<script>
import echarts from 'echarts'
import { util } from '../../utils'
import constants from './constants'
// import 'echarts/extension/bmap/bmap'
import { actions } from '../../store/constants'
let chart = null
// let provinceGeoMap = null
let countryGeoMap = null
const defaultSeries = {
  showEffectOn: 'render',
  rippleEffect: {
    brushType: 'stroke'
  },
  hoverAnimation: true,
  label: {
    show: false
  },
  itemStyle: {
    color: '#FF5500',
    borderWidth: 0,
    borderColor: 'rgba(255,85,0,0.2)'
  },
  emphasis: {
    itemStyle: {
      color: '#FF5500'
    }
  }
}
export default {
  name: 'overviewMap',
  props: {
    countryData: null,
    provinceData: null
  },
  data () {
    return {
      baseWidth: 1200,
      baseHeight: 768,
      enableDrag: false,
      top: 0,
      left: 0,
      showWorld: false,
      mapReady: true,
      geoReady: false
    }
  },
  computed: {
    style () {
      return {
        top: `${this.top}px`,
        left: `${this.left}px`
      }
    },
    ready () {
      return this.mapReady && this.geoReady
    }
  },
  watch: {
    countryData () {
      if (this.ready) this.setOptions()
    },
    provinceData () {
      if (this.ready) this.setOptions()
    },
    ready (ready) {
      if (ready) this.setOptions()
    }
  },
  async mounted () {
    this.resize()
    chart = echarts.init(this.$refs.toMap)
    // await this.getWorldJson()
    this.getGeo()
    window.addEventListener('resize', this.onResize)
  },
  beforeDestroy () {
    if (chart) {
      chart.dispose()
      chart = null
    }
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    getGeo () {
      this.$store.dispatch(actions.dataview.getGeo)
        .then(res => {
          countryGeoMap = res.data.country
          this.geoReady = true
        })
    },
    toggleMap (type) {
      this.showWorld = type === 'world'
      this.setOptions()
    },
    getWorldOption () {
      const realtimeData = this.showWorld
        ? this.getCountryData()
        : this.getProvinceData()
      const options = {
        tooltip: {
          show: true,
          formatter (params) {
            if (params.seriesType === 'map') {
              return `<span>${params.seriesName}</span><br/><span>${params.name}: ${params.value}</span>`
            } else {
              return `<span>${params.seriesName}</span><br/><span>${params.name}: ${params.value[2]}</span>`
            }
          }
        },
        bmap: {
          center: realtimeData.geoOfMax.length
            ? [realtimeData.geoOfMax[0], realtimeData.geoOfMax[1]]
            : [116.46, 39.92],
          zoom: this.showWorld ? 1 : 5,
          roam: 'move',
          mapStyle: {
            styleJson: [
              {
                featureType: 'districtlabel',
                elementType: 'labels.icon',
                stylers: {
                  visibility: 'off'
                }
              },
              {
                featureType: 'water',
                elementType: 'all',
                stylers: {
                  color: '#d1d1d1'
                }
              },
              {
                featureType: 'land',
                elementType: 'all',
                stylers: {
                  color: '#f3f3f3'
                }
              },
              {
                featureType: 'railway',
                elementType: 'all',
                stylers: {
                  visibility: 'off'
                }
              },
              {
                featureType: 'highway',
                elementType: 'all',
                stylers: {
                  color: '#fdfdfd'
                }
              },
              {
                featureType: 'highway',
                elementType: 'labels',
                stylers: {
                  visibility: 'off'
                }
              },
              {
                featureType: 'arterial',
                elementType: 'geometry',
                stylers: {
                  color: '#fefefe'
                }
              },
              {
                featureType: 'arterial',
                elementType: 'geometry.fill',
                stylers: {
                  color: '#fefefe'
                }
              },
              {
                featureType: 'poi',
                elementType: 'all',
                stylers: {
                  visibility: 'off'
                }
              },
              {
                featureType: 'green',
                elementType: 'all',
                stylers: {
                  visibility: 'off'
                }
              },
              {
                featureType: 'subway',
                elementType: 'all',
                stylers: {
                  visibility: 'off'
                }
              },
              {
                featureType: 'manmade',
                elementType: 'all',
                stylers: {
                  color: '#d1d1d1'
                }
              },
              {
                featureType: 'local',
                elementType: 'all',
                stylers: {
                  color: '#d1d1d1'
                }
              },
              {
                featureType: 'arterial',
                elementType: 'labels',
                stylers: {
                  visibility: 'off'
                }
              },
              {
                featureType: 'boundary',
                elementType: 'all',
                stylers: {
                  color: '#fefefe'
                }
              },
              {
                featureType: 'building',
                elementType: 'all',
                stylers: {
                  color: '#d1d1d1'
                }
              },
              {
                featureType: 'label',
                elementType: 'labels.text.fill',
                stylers: {
                  color: '#999999'
                }
              }
            ]
          }
        },
        // geo: {
        //   map: 'world',
        //   roam: 'move',
        //   zoom: 3,
        //   center: [65 + (window.innerWidth - this.baseWidth) / 50, 30],
        //   show: false
        // },
        series: [
          util.mergeObject(
            {
              name: '实时在线人数',
              type: 'effectScatter',
              data: realtimeData.data.filter(item => {
                return item.value[2] >= realtimeData.max * 0.8
              }),
              coordinateSystem: 'bmap',
              symbolSize: function (val) {
                return (val[2] / realtimeData.max) * 50
              }
            },
            util.clone(defaultSeries)
          ),
          util.mergeObject(
            {
              name: '实时在线人数',
              type: 'scatter',
              data: realtimeData.data.filter(item => {
                return item.value[2] < realtimeData.max * 0.8
              }),
              coordinateSystem: 'bmap',
              symbolSize: function (val) {
                const size = (val[2] / realtimeData.max) * 50
                return size < 2 ? 2 : size
              }
            },
            util.clone(defaultSeries)
          )
        ]
      }
      return options
    },
    getCountryData () {
      let realtimeData = []
      let max = 0
      let geoOfMax = []
      for (let prop in this.countryData) {
        if (!countryGeoMap[prop]) continue
        const geo = util.clone(countryGeoMap[prop]).reverse()
        if (this.countryData[prop] > max) {
          max = this.countryData[prop]
          geoOfMax = geo
        }
        realtimeData.push({
          name: prop,
          value: [...geo, this.countryData[prop]]
        })
      }
      return {
        data: realtimeData,
        max,
        geoOfMax
      }
    },
    getProvinceData () {
      let realtimeData = []
      let max = 0
      let geoOfMax = []
      for (let prop in this.provinceData) {
        const geo = this.provinceData[prop].geo
        const value = this.provinceData[prop].value
        if (value > max) {
          max = value
          geoOfMax = geo
        }
        realtimeData.push({
          name: prop,
          value: [...geo, value]
        })
      }
      return {
        data: realtimeData,
        max,
        geoOfMax
      }
    },
    getProvinceOption () {
      const realtimeData = this.getProvinceData()
      const options = {
        tooltip: {
          show: true,
          formatter (params) {
            if (params.seriesType === 'map') {
              return `<span>${params.seriesName}</span><br/><span>${params.name}: ${params.value}</span>`
            } else {
              return `<span>${params.seriesName}</span><br/><span>${params.name}: ${params.value[2]}</span>`
            }
          }
        },
        geo: {
          map: 'china',
          center: [73 + (window.innerWidth - this.baseWidth) / 50, 30],
          show: true,
          zoom: 0.9,
          roam: 'move'
        },
        series: [
          util.mergeObject(
            {
              name: '实时在线人数',
              type: 'effectScatter',
              data: realtimeData.data,
              coordinateSystem: 'geo',
              symbolSize: function (val) {
                return (val[2] / realtimeData.max) * 40
              }
            },
            util.clone(defaultSeries)
          )
        ]
      }
      return options
    },
    setOptions () {
      const worldOptions = this.getWorldOption()
      // const provinceOptions = this.getProvinceOption()
      let options = util.mergeObject(
        {
          color: constants.color,
          grid: {
            width: '100%',
            height: '100%'
          }
        },
        // this.showWorld ? worldOptions : provinceOptions
        worldOptions
      )
      if (chart) chart.setOption(options)
      this.$nextTick(() => {
        chart.resize()
      })
    },
    onResize () {
      this.resize()
    },
    resize () {
      this.setOptions()
    }
  }
}
</script>
<style lang="sass">
@import '../../assets/constants'
.BMap_cpyCtrl,.anchorBL
  display: none
.overview-map
  position: absolute
  top: 0
  left: 0
  width: 100%
  height: 100%
</style>
